"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var date_1 = require("@/react-app/common/utils/date/date");
function VersionInfo(_a) {
    var _b;
    var historyItem = _a.historyItem, hideLink = _a.hideLink, onLinkClicked = _a.onLinkClicked;
    var t = (0, react_i18next_1.useTranslation)().t;
    var timeZone = (0, date_1.getUserTimezone)();
    var timestamp = historyItem.timestamp;
    var formattedDate = new Date(timestamp).toISOString().slice(0, 19).replace('T', ' ');
    var postAuthor = t("MODERATION.QUEUE_VIEW.JOB_VERSION.".concat(historyItem.actor.domain === 'agent' ? 'POSTED_BY_AGENT' : 'POSTED_BY_OTHER'), {
        ACTOR_ID: historyItem.actor.id,
    });
    return (react_1.default.createElement("div", { className: "job-version-info" },
        react_1.default.createElement("span", { className: "history-info", title: (_b = t('DASHBOARD.STATISTICS.TIMEZONE_TOOLTIP_R18N', { timeZone: timeZone })) !== null && _b !== void 0 ? _b : '' }, "".concat(postAuthor, " ").concat(formattedDate)),
        !hideLink && (react_1.default.createElement("a", { className: "job-version-info-link", onClick: onLinkClicked },
            t('MODERATION.QUEUE_VIEW.JOB_VERSION.BACK_LINK'),
            react_1.default.createElement("i", { className: "implioicons-arrow-up job-version-info-link-icon", "aria-hidden": "true" })))));
}
exports.default = VersionInfo;
